import React from 'react'
import './CSS/Wishlist.css'
import WishlistItems from '../Components/WishlistItems/WishlistItems'
const Wishlist = () => {
  return (
    <div>
      <WishlistItems/>
    </div>
  )
}

export default Wishlist
